interface IconProps {
  color?: string;
  className?: string;
}

export default function ProfilteIcon({
  color = "#8E929E",
  className = "",
}: IconProps) {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="0.5"
        y="0.5"
        width="23.5321"
        height="23.5321"
        rx="4.5"
        stroke={color}
      />
      <g clipPath="url(#clip0_6675_62291)">
        <path
          d="M6.28638 9.80037H13.3186C13.4503 10.4005 13.9864 10.852 14.6268 10.852C15.2671 10.852 15.8032 10.4005 15.9349 9.80037H17.9785C18.1366 9.80037 18.2649 9.67235 18.2649 9.51461C18.2649 9.35687 18.1366 9.22885 17.9785 9.22885H15.9349C15.8032 8.62875 15.2671 8.17725 14.6268 8.17725C13.9864 8.17725 13.4503 8.62875 13.3186 9.22885H6.28638C6.1283 9.22885 6 9.35687 6 9.51461C6 9.67235 6.1283 9.80037 6.28638 9.80037ZM14.6268 8.63446C15.0128 8.63446 15.3404 8.88365 15.4596 9.22885C15.4905 9.31915 15.5077 9.41402 15.5077 9.51461C15.5077 9.6152 15.4905 9.71007 15.4596 9.80037C15.3404 10.1456 15.0128 10.3948 14.6268 10.3948C14.2407 10.3948 13.9131 10.1456 13.794 9.80037C13.7631 9.71007 13.7459 9.6152 13.7459 9.51461C13.7459 9.41402 13.7631 9.31915 13.794 9.22885C13.9131 8.88365 14.2407 8.63446 14.6268 8.63446Z"
          fill={color}
        />
        <path
          d="M17.9797 14.7313H15.9361C15.8043 14.1312 15.2683 13.6797 14.6279 13.6797C13.9876 13.6797 13.4515 14.1312 13.3198 14.7313H6.28638C6.1283 14.7313 6 14.8593 6 15.0171C6 15.1748 6.1283 15.3028 6.28638 15.3028H13.3186C13.4503 15.9029 13.9864 16.3544 14.6268 16.3544C15.2671 16.3544 15.8032 15.9029 15.9349 15.3028H17.9785C18.1366 15.3028 18.2649 15.1748 18.2649 15.0171C18.2649 14.8593 18.1366 14.7313 17.9785 14.7313H17.9797ZM14.6268 15.8972C14.2407 15.8972 13.9131 15.648 13.794 15.3028C13.7631 15.2125 13.7459 15.1176 13.7459 15.0171C13.7459 14.9165 13.7631 14.8216 13.794 14.7313C13.9131 14.3861 14.2407 14.1369 14.6268 14.1369C15.0128 14.1369 15.3404 14.3861 15.4596 14.7313C15.4905 14.8216 15.5077 14.9165 15.5077 15.0171C15.5077 15.1176 15.4905 15.2125 15.4596 15.3028C15.3404 15.648 15.0128 15.8972 14.6268 15.8972Z"
          fill={color}
        />
        <path
          d="M17.9797 11.9803H13.0563C12.9246 11.3802 12.3885 10.9287 11.7481 10.9287C11.1078 10.9287 10.5717 11.3802 10.44 11.9803H6.28638C6.1283 11.9803 6 12.1083 6 12.2661C6 12.4238 6.1283 12.5518 6.28638 12.5518H10.4388C10.5706 13.1519 11.1066 13.6034 11.747 13.6034C12.3873 13.6034 12.9234 13.1519 13.0551 12.5518H17.9785C18.1366 12.5518 18.2649 12.4238 18.2649 12.2661C18.2649 12.1083 18.1366 11.9803 17.9785 11.9803H17.9797ZM11.747 13.1462C11.3609 13.1462 11.0333 12.897 10.9142 12.5518C10.8833 12.4615 10.8661 12.3667 10.8661 12.2661C10.8661 12.1655 10.8833 12.0706 10.9142 11.9803C11.0333 11.6351 11.3609 11.3859 11.747 11.3859C12.133 11.3859 12.4606 11.6351 12.5798 11.9803C12.6107 12.0706 12.6279 12.1655 12.6279 12.2661C12.6279 12.3667 12.6107 12.4615 12.5798 12.5518C12.4606 12.897 12.133 13.1462 11.747 13.1462Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_6675_62291">
          <rect
            width="12.266"
            height="8.17735"
            fill="white"
            transform="translate(6 8.17725)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
